import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Box } from 'core/components';
import VerticalDetailTabs from 'app/components/detailTabs/VerticalDetailTabs';
import TabbedChart from 'app/components/tabbedChart/TabbedChart';
import Page from 'app/components/page/Page';
import InsightsMenu from 'app/components/navbar/InsightsMenu';

import AggregateViewHeader from '../aggregate/AggregateViewHeader';
import parentLinks from '../NetworkExplorerParentLink';

@inject('$tabs')
@observer
class ServiceDetails extends Component {
  constructor(props) {
    super(props);

    const { $tabs } = props;
    const tabs = $tabs.getTabs();

    this.state.tabBlacklist = [tabs.SERVICE.id];
  }

  state = {
    filters: [],
    lookback_seconds: 86400,
    aggregateType: 'p95th_bits_per_sec'
  };

  get port() {
    const { match } = this.props;
    const [port] = match.params.service.split('-');
    return port;
  }

  get protocol() {
    const { match } = this.props;
    const [, protocol] = match.params.service.split('-');
    return protocol;
  }

  get filters() {
    const { filters } = this.state;

    const portFilter = {
      filterField: 'port',
      filterValue: this.port
    };

    const protocolFilter = {
      filterField: 'i_protocol_name',
      filterValue: this.protocol
    };

    return filters.concat(portFilter, protocolFilter);
  }

  handleFiltersApply = (filters) => {
    this.setState({ filters });
  };

  handleLookbackChange = (lookback_seconds) => {
    this.setState({ lookback_seconds });
  };

  handleAggregationChange = (aggregateType) => {
    this.setState({ aggregateType });
  };

  render() {
    const { aggregateType, filters, lookback_seconds, tabBlacklist } = this.state;

    return (
      <Page
        title={`${this.protocol}/${this.port}`}
        parentLinks={[...parentLinks, { link: '/v4/core/quick-views/service', label: 'Services' }]}
        insightsMenu={
          <InsightsMenu query="fetchServiceInsights" params={{ protocol: this.protocol, port: this.port }} />
        }
        scrolls
        showExport
      >
        <AggregateViewHeader
          title={`Port: ${this.port}, Protocol: ${this.protocol}`}
          aggregateType={aggregateType}
          filters={filters}
          lookbackSeconds={lookback_seconds}
          onFiltersChange={this.handleFiltersApply}
          onAggregateChange={this.handleAggregationChange}
          onMetricsChange={this.handleAggregationChange}
          onTimeRangeChange={this.handleLookbackChange}
        />

        <Box mb={2}>
          <TabbedChart overrides={{ lookback_seconds, aggregateTypes: [aggregateType] }} simpleFilters={this.filters} />
        </Box>

        <VerticalDetailTabs
          blacklist={tabBlacklist}
          simpleFilters={this.filters}
          queryOverrides={{ lookback_seconds, aggregateTypes: [aggregateType] }}
        />
      </Page>
    );
  }
}

export default ServiceDetails;
